/** One of a project's swimlanes — its own name (also its label) and a color. */
export interface PhaseDef {
  name: string;
  color: string;
}

/**
 * The swimlanes every project started with before they became per-project editable.
 * Also the fallback for any project that hasn't saved its own list yet, so an
 * untouched project looks exactly as it always did.
 */
export const DEFAULT_PHASES: PhaseDef[] = [
  { name: "Logistics", color: "var(--s-prep)" },
  { name: "Installation", color: "var(--s-install)" },
  { name: "Commissioning", color: "var(--s-comm)" },
  // Matches the literal `phase` value already stored on existing tasks (see
  // seedData.ts) — renaming the label used to happen in the now-removed
  // PHASE_LABEL map ("IT / network"); the name is the label now, so it can't
  // drift from the stored value the way that cosmetic label used to.
  { name: "IT/Network", color: "var(--s-it)" },
];

/**
 * A phase's color, tolerant of one that no longer exists in the project's current
 * list — renaming or deleting a swimlane doesn't rewrite the tasks that were in it,
 * so a lookup miss is expected, not a bug. Falls back to a neutral gray rather than
 * `undefined`, which would otherwise silently break an inline `background:` style.
 */
export function phaseColor(phases: PhaseDef[], name: string): string {
  return phases.find((p) => p.name === name)?.color ?? "#9a9890";
}
